import View from '@/components/common/view'
import flexibleEmployerIndex from '../components/flexibleEmployer/Index';
import flexibleEmployerPolicyDetail from '../components/flexibleEmployer/detail/Policy';

export default [
	{
		path:'',
		component:flexibleEmployerIndex,
	},
	{
		path:'policy-detail/:id',
		component:flexibleEmployerPolicyDetail,
	}
]


// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/flexibleEmployer.js